







import Vue from 'vue';

interface Props {
  sources: Array<unknown>;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    sources: {
      type: Array,
      required: true,
    },
  },
});
